// © Microsoft Corporation. All rights reserved.
import React from 'react';
import { connect } from 'react-redux';
import { DefaultButton, PrimaryButton, Stack } from '@fluentui/react';
import { VideoCameraEmphasisIcon } from '@fluentui/react-icons-northstar';
import {
    endCallTitleStyle,
    buttonStyle,
    buttonsStackTokens,
    videoCameraIconStyle,
    stackItemStyles,
    stackBtnItemStyles,
    stackStyles
} from './styles/EndCall.styles';
import {
    setCallState
} from '../core/actions/calls';

const mapDispatchToProps = (dispatch: any) => ({
    setCallState: async (msg: string) => dispatch(setCallState(msg))
});

const mapStateToProps = () => ({
});

export interface EndCallProps {
    message: string;
    rejoinHandler(): void;
    homeHandler(): void;
    setCallState(msg: string | null): any;
    darkColor: string;
    lightColor: string;
}

const EndCall = (props: EndCallProps): JSX.Element => {
    const goHomePage = 'Go to home page';
    // const rejoinCall = 'Rejoin call';

    return (
        <Stack styles={stackStyles}>
            <Stack.Item styles={stackItemStyles}>
                <div className={endCallTitleStyle} style={{ textAlign: 'center' }}>{props.message}</div>
            </Stack.Item>
            <Stack.Item styles={stackBtnItemStyles}>
                <Stack horizontal tokens={buttonsStackTokens} horizontalAlign="center" verticalAlign="center">
                    <DefaultButton className={buttonStyle(props)} onClick={() => {
                        props.rejoinHandler();
                        props.setCallState('Connected');
                    }}>
                        {/* <VideoCameraEmphasisIcon className={videoCameraIconStyle} size="medium" /> */}
                        {goHomePage}
                    </DefaultButton>
                    {/* <DefaultButton className={buttonStyle} onClick={props.homeHandler}>
                        {goHomePage}
                    </DefaultButton> */}
                </Stack>
            </Stack.Item>
        </Stack>
    );
};
export default connect(mapStateToProps, mapDispatchToProps)(EndCall);